import { useEffect, useState } from "react";
import api, { fmtUSD } from "@/lib/api";
import { Panel, Metric, Empty } from "@/components/terminal";

export default function Traditional() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-slate-500 font-mono text-sm">Loading…</div>;
  const core = d.buckets.find((b) => b.key === "core_capital");
  const target = (d.allocations || []).find((a) => a.key === "core_traditional");
  return (
    <div className="space-y-5" data-testid="traditional-page">
      <h2 className="font-display text-xl font-bold">Traditional Assets</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <Metric label="Traditional Asset Value" value={fmtUSD(d.traditional_value)} testId="traditional-value" />
        <Metric label="Core Capital Bucket (cash)" value={fmtUSD(core?.balance)} testId="traditional-core-cash" />
        <Metric label="Target Allocation" value={`${target?.target_pct ?? 35}%`} sub={`band ${target?.min_pct}–${target?.max_pct}%`} testId="traditional-target" />
      </div>
      <Panel title="Status" testId="traditional-status">
        <Empty>
          No traditional brokerage connection is configured. Cash earmarked for core traditional assets is held
          in the Core Capital bucket and counted as cash until a brokerage provider (Phase 4) is connected.
          No balances are invented.
        </Empty>
      </Panel>
    </div>
  );
}
